import { ref, type Ref } from 'vue';

interface ViewportSize {
  width: Ref<number>;
  height: Ref<number>;
}

const width = ref(typeof window !== 'undefined' ? window.innerWidth : 0);
const height = ref(typeof window !== 'undefined' ? window.innerHeight : 0);
let installed = false;
let rafHandle = 0;

const install = (): void => {
  if (installed || typeof window === 'undefined') return;
  installed = true;
  window.addEventListener('resize', () => {
    if (rafHandle !== 0) return;
    rafHandle = requestAnimationFrame(() => {
      rafHandle = 0;
      width.value = window.innerWidth;
      height.value = window.innerHeight;
    });
  });
};

export const useViewportSize = (): ViewportSize => {
  install();
  return { width, height };
};

export const __setViewportSizeForTests = (value: {
  width?: number;
  height?: number;
}): void => {
  if (value.width !== undefined) width.value = value.width;
  if (value.height !== undefined) height.value = value.height;
};
